export const APIConsumer_address = "0xfe72F27D1454591757c30Cb5958Ed0F257BFFa5C";
export const VRF_address = "0x91c637bc10E657D0dE53eA9ad9527559f2Ee8a53";
export const Swaper_address = "0x0bba2eE16cF1F786Cb568D9f5f47cb8276DdECFF";
export const VjkNFT_address = "0x4A9f1122c1898DE7218B5eF5b49c4EFEB23Db1D6";

export const link_oracle_address = {
  goerli: "0xCC79157eb46F5624204f47AB42b3906cAA40eaB7",
};
export const swaper_router_address = {
  goerli: "0xE592427A0AEce92De3Edee1F18E0157C05861564",
};
export const wrapper_address = {
  goerli: "0x708701a1DfF4f478de54383E49a627eD4852C816",
};
export const link_token_address = {
  mainnet: "0x514910771AF9Ca656af840dff83E8264EcF986CA",
  goerli: "0x326C977E6efc84E512bB9C30f76E30c160eD06FB",
};
export const weth_token_address = {
  mainnet: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
  goerli: "0xB4FBF271143F4FBf7B91A5ded31805e42b2208d6",
};
export const chainlink_registry_address =
  "0x02777053d6764996e594c3E88AF1D58D5363a2e6"; // The same for mainnet and goerli
export const chainlink_registrar_address = {
  mainnet: "0xDb8e8e2ccb5C033938736aa89Fe4fa1eDfD15a1d",
  goerli: "0x9806cf6fBc89aBF286e8140C42174B94836e36F2",
};
